import {autoImplement} from '@/util';
import moment from 'moment';

export interface ApiContactHistoryEmail {
  Datei: Array<{
    Dateiname: string,
    DownloadToken: string,
  }>,
  AnlageDatum: string,
  State: number,
  Art: string,
  Id: number,
}

export interface DetailContactHistoryEmailFilters {
  KundenNr?: number;
  KontaktNr?: number;
  Id?: number;
}

export class ContactHistoryEmail extends autoImplement<ApiContactHistoryEmail>() {
  static fromApi(apiContactHistoryMail: ApiContactHistoryEmail): ContactHistoryEmail {
    return new ContactHistoryEmail(apiContactHistoryMail);
  }
  get AnlageDatumFormatted() {
    return moment(this.AnlageDatum).format('DD.MM.YYYY HH:mm');
  }
  get color() {
    return this.State ? 'blue' : 'green';
  }
  get stateIcon() {
    return this.State ? 'mdi-email-arrow-right' : 'mdi-email-arrow-left';
  }
}
